<template>
  <div class="ProductService">
    <div class="serviceTop">
      <div class="tilte">灵活用途</div>
      <div class="flexWrap">
        <div v-for="(item, index) in purposeList" :key="index" class="every">
          <div class="m32">
            <div class="tilte">{{ item.tilte }}</div>
            <div>{{ item.text }}</div>
          </div>
        </div>
      </div>
      <img src="@/assets/Slicebl.png" alt="" />
    </div>

    <div class="serviceMain">
      <div
        v-for="(item, index) in purposeList1"
        :key="index"
        :class="[
          'every',
          {
            everyBle: item.place == 'left',
          },
        ]"
      >
        <img :src="item.url" alt="" v-if="item.place == 'left'" />
        <div
          :class="[
            {
              everyRight: item.place == 'right',
              everyLeft: item.place == 'left',
            },
          ]"
        >
          <div class="tilte">{{ item.tilte }}</div>
          <div v-for="(it, idx) in item.list" :key="idx">
            <span>{{ it.tilte }}</span> {{ it.text }}
          </div>
        </div>

        <img :src="item.url" alt="" v-if="item.place == 'right'" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      purposeList: [
        {
          tilte: "佣金结算",
          text: "Commission Settlement",
        },
        {
          tilte: "费用代发",
          text: "Reimbursement of expenses",
        },
        {
          tilte: "工资代发",
          text: "salary processing",
        },
        {
          tilte: "个税申报",
          text: "Income tax declaration",
        },
        {
          tilte: "获取发票",
          text: "Obtain the invoice",
        },
        {
          tilte: "弹性用工",
          text: "Flexible employment",
        },
        {
          tilte: "临时用工",
          text: "Temporary employment",
        },
        {
          tilte: "兼职用工",
          text: "Part-time personnel",
        },
        {
          tilte: "劳务用工",
          text: "contract workers",
        },
        {
          tilte: "合规用工",
          text: "Compliance employment",
        },
      ],
      purposeList1: [
        {
          url: require("@/assets/Sliceser.png"),
          tilte: "供需匹配与用工管理",
          place: "right",
          list: [
            {
              tilte: "1.需求发布：",
              text: "企业可发布长期、短期、临时用工需求，标注技能要求、薪资范围及工作地点。 ",
            },
            {
              tilte: "2.智能推荐：",
              text: "平台通过算法为持证人员推送高匹配岗位，支持一键接单、在线签约。 ",
            },
            {
              tilte: "3. 全流程管理：",
              text: " 从考勤打卡、作业记录到薪资结算，全程数字化留痕，降低纠纷风险。 ",
            },
          ],
        },
        {
          url: require("@/assets/Sliceser2.png"),
          tilte: "培训与认证服务",
          place: "left",
          list: [
            {
              tilte: "1.在线学习：",
              text: "提供理论课程、实操视频、模拟题库，支持碎片化学习。 ",
            },
            {
              tilte: "2.考试取证：",
              text: "无证人员注册的，及时提醒培训取证，有针对性地组织培训和考证，在此基础上提供就业服务，帮助企业解决专业岗位用工需求，提高就业收入；有证人员通过持证核验，可以就近接单，提高接单成功率。 ",
            },
          ],
        },
        {
          url: require("@/assets/Sliceser.png"),
          tilte: "安全监管与风险防控",
          place: "right",
          list: [
            {
              tilte: "1.专业技术人员100%持证上岗：",
              text: "为确保作业安全与质量，对所有入驻的特种作业实施严格的资质审核流程，对所持证件验证真伪，从源头上保障作业安全与质量，让企业用得安心。 ",
            },
            {
              tilte: "2.  保险服务：",
              text: "与保险公司合作，针对行业作业特点，推出优于行业的保险服务解决方案。提供按日购买、按次购买等保险综合服务解决方案，为企业和特种作业人员提供全方位的保障。 ",
            },
          ],
        },

        {
          url: require("@/assets/Sliceser3.png"),
          tilte: "数据分析与决策支持",
          place: "left",
          list: [
            {
              tilte: "1.动态数据库：",
              text: " 平台自动统计各项数据，通过数据分析挖掘数据背后的规律和趋势，为平台功能优化、运营策略调整提供数据支持。  ",
            },
            {
              tilte: "2. 政府监管接口：",
              text: "平台增设政府监管账号，全流程动态监管，实现从“管理”到“防治”的转变，更加注重预防和治本措施。 ",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.ProductService {
  margin-top: 28px;
}
.serviceTop {
  background: #f4f7fc;
  font-family: PingFang SC, PingFang SC;
  padding: 52px 368px;
  img {
    margin-top: 58px;
  }
  .tilte {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
    margin-bottom: 32px;
  }
  .every {
    width: 220px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(140, 140, 140, 0.25);
    border-radius: 4px 4px 4px 4px;
    font-weight: 400;
    font-size: 12px;
    color: #141414;
    margin-bottom: 28px;
    text-align: left;
    .m32 {
      margin: 32px 30px;
    }
    .tilte {
      font-weight: 500;
      font-size: 18px;
      color: #141414;
      margin-bottom: 15px;
    }
  }
}
/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .serviceTop {
    padding: 52px 100px;
    img {
      width: 100%;
      height: 100px;
    }
  }
}
.serviceMain {
  font-family: PingFang SC, PingFang SC;
  .every {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 36px;
    text-align: left;
    padding: 80px 432px 68px 406px;

    .tilte {
      font-weight: bold;
      font-size: 32px;
      color: #141414;
      margin-bottom: 35px;
    }
    span {
      font-weight: 500;
      font-size: 16px;
      color: #141414;
    }
    .everyRight {
      width: 466px;
    }
    .everyLeft {
      width: 466px;
    }
  }
  .everyBle {
    background: #f4f7fc;
  }
}
/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .serviceMain {
    // padding: 52px 100px;
    img {
      width: 100%;
      height: 460px;
    }
    .every {
      padding: 80px 200px 68px 200px;
    }
  }
}
.flexWrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
